import { Component } from '@verndale/core';
import { isFocusable } from '../../helpers';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      button: this.el.querySelector('.modal-card__btn')
    };
    this.heading = this.el.dataset.heading;
    this.copy = this.el.dataset.copy;

    this.ignoreUtilFocusChanges = false;
    this.lastFocus = null;

    this.handleModalClickOutside = this.handleModalClickOutside.bind(this);
    this.handleEscape = this.handleEscape.bind(this);
    this.handleFocus = this.handleFocus.bind(this);

    this.dom = {
      body: document.querySelector('body')
    };
  }

  addListeners() {
    if (this.dom.button && this.el.dataset.module !== 'threeColumnIcon') {
      this.dom.button.addEventListener(
        'click',
        this.handleModalOpen.bind(this)
      );
      this.dom.button.addEventListener(
        'keypress',
        this.handleModalOpenKeyboard.bind(this)
      );
    }
  }

  removeListeners() {
    this.dom.modal.removeEventListener('click', this.handleModalClickOutside);
    document.removeEventListener('keyup', this.handleEscape);
    document.removeEventListener('focus', this.handleFocus, true);
  }

  buildHtml() {
    this.dom.modal = document.createElement('div');
    this.dom.modal.classList.add('three-column-modal');
    this.dom.modal.innerHTML = `
      <div class="three-column-modal__inner">
        <button class="three-column-modal__close" aria-label="Close">
          <svg viewBox="0 0 20 20">
            <use xlink:href="#close" />
          </svg>
        </button>
        <h2 class="three-column-modal__heading">${this.heading}</h2>
        <div class="rtf">${this.copy}</div>
      </div>
    `;
    this.dom.close = this.dom.modal.querySelector('.three-column-modal__close');
    this.dom.content = this.dom.modal.querySelector(
      '.three-column-modal__inner'
    );
    this.dom.bio = this.dom.modal.querySelector('.three-column-modal__bio');

    this.dom.button = document.createElement('button');

    /* While the following 4 lines could be written as:
     * `this.dom.button.classList = 'btn btn--primary btn--outline three-column-modal__show-more';`
     * IE 11 does not support assignment to classList
     * Rather than add a polyfill, the lines were broken out.
     */
    this.dom.button.classList.add('btn');
    this.dom.button.classList.add('btn--primary');
    this.dom.button.classList.add('btn--outline');
    this.dom.button.classList.add('three-column-modal__show-more');
    this.dom.button.innerHTML = this.showMoreLabel;

    this.dom.close.addEventListener('click', this.handleModalClose.bind(this));

    this.dom.modal.addEventListener('click', this.handleModalClickOutside);
    document.addEventListener('keyup', this.handleEscape);
    document.addEventListener('focus', this.handleFocus, true);
  }

  handleModalOpen() {
    this.buildHtml();

    const scrollY = window.scrollY;
    this.dom.body.style.position = 'fixed';
    this.dom.body.style.top = `-${scrollY}px`;
    this.dom.body.classList.add('has-modal');
    this.dom.body.appendChild(this.dom.modal);
    this.focusFirstDescendant(this.dom.modal);
  }

  handleModalOpenKeyboard(e) {
    const key = e.which || e.keyCode;

    if (key === 13 || key === 32) {
      e.preventDefault();
      this.handleModalOpen();
    }
  }

  handleModalClose() {
    this.removeListeners();

    const scrollY = document.body.style.top;
    this.dom.body.style.position = 'static';
    this.dom.body.style.top = '';
    this.dom.body.classList.remove('has-modal');
    this.dom.body.removeChild(this.dom.modal);
    window.scrollTo(0, parseInt(scrollY || '0') * -1);
    this.el.focus();
  }

  handleModalClickOutside(e) {
    if (e.target === this.dom.content || this.dom.content.contains(e.target)) {
      return;
    }

    this.handleModalClose();
  }

  handleEscape(e) {
    const key = e.which || e.keyCode;

    if (key === 27) {
      e.stopPropagation();

      this.handleModalClose();
    }
  }

  handleFocus(e) {
    if (this.ignoreUtilFocusChanges) return;

    if (this.dom.modal.contains(e.target)) {
      this.lastFocus = e.target;
    } else {
      this.focusFirstDescendant(this.dom.modal);

      if (this.lastFocus === document.activeElement) {
        this.focusLastDescendant(this.dom.modal);
      }
      this.lastFocus = document.activeElement;
    }
  }

  focusFirstDescendant(element) {
    for (let i = 0; i < element.childNodes.length; i++) {
      const child = element.childNodes[i];
      if (this.attemptFocus(child) || this.focusFirstDescendant(child)) {
        return true;
      }
    }
    return false;
  }

  focusLastDescendant(element) {
    for (let i = element.childNodes.length - 1; i >= 0; i--) {
      const child = element.childNodes[i];
      if (this.attemptFocus(child) || this.focusLastDescendant(child)) {
        return true;
      }
    }
    return false;
  }

  attemptFocus(element) {
    if (!isFocusable(element)) {
      return false;
    }

    this.ignoreUtilFocusChanges = true;
    try {
      element.focus();
    } catch (e) {
      return;
    }
    this.ignoreUtilFocusChanges = false;
    return document.activeElement === element;
  }
}

export default Module;
